<pg-header
  title="Gates"
  ticon="database"
  bckbtn="true"
  bckurl="/setup"
></pg-header>
@if (usrAcsErrMsg == false) {
<div>
  <div>
    <div class="ds-card grid">
      @if (shwLdg) {
      <ds-loading></ds-loading>
      }
      <app-data-grid
        id="gridContainer"
        style="width: 100%"
        [dataSource]="gteLst"
        [legacyColumns]="columnDefs"
        [searchPanel]="true"
        [filterRow]="true"
        [filterPanel]="true"
        [groupPanel]="true"
        [columnChooser]="true"
        [allowExport]="(USER_PERMISSIONS.exprt_in==1)?true:false"
        exportFileName="LMO Details"
        [pageSize]="10"
        [allowedPageSizes]="[10, 25, 50, 100]"
        [showPageSizeSelector]="true"
        [rowAlternationEnabled]="true"
        [showBorders]="true"
      >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="(USER_PERMISSIONS.updt_in==1)?true:false"
          type="buttons"
          [width]="100"
          caption="Edit"
          cellTemplate="editTemplate"
        ></app-grid-column>
        <ng-template appGridCell="editTemplate" let-data="cell"
          ><div>
            <div
              class="cursor-pointer tblEdtBtn"
              (click)="onCellClick('edit',data)"
            >
              Edit
            </div>
          </div></ng-template
        >
        <app-grid-column
          [showInColumnChooser]="false"
          [visible]="(USER_PERMISSIONS.dlte_in==1)?true:false"
          type="buttons"
          [width]="100"
          caption="Delete"
          cellTemplate="delTemplate"
        ></app-grid-column>
        <ng-template appGridCell="delTemplate" let-data="cell"
          ><div>
            <div
              class="cursor-pointer tblDelBtn"
              (click)="onCellClick('delete',data)"
            >
              Delete
            </div>
          </div></ng-template
        >
      </app-data-grid>
    </div>
  </div>
  <nz-drawer
    [nzBodyStyle]="{ height: 'calc(100% - 55px)', overflow: 'auto', 'padding-bottom': '53px' }"
    [nzMaskClosable]="false"
    [nzWidth]="370"
    [nzVisible]="shwSidebar"
    [nzTitle]="sidebarHeading"
    (nzOnClose)="closeSideBar()"
  >
    <div class="gteMrgn">
      <div class="inptLbl">Gate Name</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input
          type="text"
          nz-input
          [(ngModel)]="gteDt.gte_nm"
          placeholder="Enter gate name"
        />
      </nz-input-wrapper>
    </div>
    <div class="gteMrgn">
      <div class="inptLbl">House Number</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input
          type="number"
          nz-input
          [(ngModel)]="gteDt.gte_hse_nu"
          placeholder="Enter house number"
        />
      </nz-input-wrapper>
    </div>
    <!-- <div class="inptLbl">Door Number</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input type="text" nz-input [(ngModel)]="gteDt.gte_dr_nu" placeholder="Enter door number" />
      </nz-input-wrapper> -->
    <div class="gteMrgn">
      <div class="inptLbl">Total Households</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input
          type="number"
          nz-input
          [(ngModel)]="gteDt.hse_ct"
          placeholder="Enter total households"
        />
      </nz-input-wrapper>
    </div>
    <div class="gteMrgn">
      <div class="inptLbl">Total Population</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input
          type="number"
          nz-input
          [(ngModel)]="gteDt.pltn_ct"
          placeholder="Enter total population"
        />
      </nz-input-wrapper>
    </div>
    <div class="gteMrgn">
      <div class="inptLbl">Latitude</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input
          type="text"
          nz-input
          [(ngModel)]="gteDt.lat"
          placeholder="Enter latitude"
        />
      </nz-input-wrapper>
    </div>
    <div class="gteMrgn">
      <div class="inptLbl">Longitude</div>
      <nz-input-wrapper [nzSuffix]="inputClearTpl">
        <input
          type="text"
          nz-input
          [(ngModel)]="gteDt.lng"
          placeholder="Enter longitude"
        />
      </nz-input-wrapper>
    </div>
    <div class="gteMrgn">
      <div class="inptLbl">Micropockets</div>
      <input
        placeholder="Select micropockets"
        nz-input
        [(ngModel)]="gteDt.mcrpt_nm"
        [nzAutocomplete]="mpauto"
      />
      <nz-autocomplete #mpauto>
        @for (d of micropockets; track d) {
        <nz-auto-option
          [nzValue]="d.mcrpt_id"
          (ngModelChange)="onmcrptChange($event)"
        >
          {{d.mcrpt_nm}}</nz-auto-option
        >
        }
      </nz-autocomplete>
    </div>
    <div class="gteMrgn">
      <div class="inptLbl">ULB</div>
      <input
        placeholder="Select ulb"
        nz-input
        [(ngModel)]="gteDt.ulb_nm"
        (ngModelChange)="onulbChange($event)"
        [nzAutocomplete]="auto"
      />
      <nz-autocomplete #auto>
        @for (d of ulbs; track d) {
        <nz-auto-option [nzValue]="d.ulb_id" (click)="getULBID(d.ulb_id);"
          >{{d.ulb_nm}}
        </nz-auto-option>
        }
      </nz-autocomplete>
    </div>
    <ng-template #inputClearTpl
      >@if (gteDt.gte_nm) {
      <i
        nz-icon
        class="ant-input-clear-icon"
        nzTheme="fill"
        nzType="close-circle"
        (click)="gteDt = {}"
      ></i>
      }</ng-template
    >
    @if (shwGteEditDiv==false && shwGteDelDiv==false) {
    <button nz-button nzType="primary" class="sbmtBtm" (click)="saveGte()">
      Submit
    </button>
    } @if (shwGteEditDiv==true && shwGteDelDiv==false) {
    <button nz-button nzType="primary" class="sbmtBtm" (click)="saveEditGte()">
      Update
    </button>
    } @if (shwGteEditDiv==false && shwGteDelDiv==true) {
    <button
      nz-button
      nzType="primary"
      class="sbmtBtm"
      nz-popconfirm
      nzPopconfirmTitle="Are you sure delete this gate?"
      nzPopconfirmPlacement="bottom"
      (nzOnConfirm)="saveDeleteGte()"
      (nzOnCancel)="cancel()"
    >
      Delete
    </button>
    } @if (shwSidebar) {
    <button nz-button nzType="default" class="cnclBtn" (click)="oncancel()">
      Cancel
    </button>
    }
  </nz-drawer>
  <!-- </div>
  </div>
</div> -->
</div>
} @if (usrAcsErrMsg == true) {
<div class="permMsg">
  <nz-result
    nzStatus="error"
    nzTitle="Access Denied"
    nzSubTitle="You do not have permissions to do this operation. Please contact Administrator to get permissions."
  >
    <!-- <div nz-result-extra>
      <button nz-button nzType="primary" (click)="bckToHm()">Back to home</button>
    </div> -->
  </nz-result>
</div>
}
